import { SkyscannerMichelinRecommendationsV1Recommendations } from '@skyscanner-internal/michelin-web-http-client';

const PATH_PREFIX = '/g/michelin';
const TRANSIENT_GRPC_CODES = new Set([4, 8, 14]); // DEADLINE_EXCEEDED, RESOURCE_EXHAUSTED, UNAVAILABLE
const MAX_RETRIES = 3;

type RecommendationsRequest =
  SkyscannerMichelinRecommendationsV1Recommendations.RecommendationsRequest;
type RecommendationsResponse =
  SkyscannerMichelinRecommendationsV1Recommendations.RecommendationsResponse;

const isTransientGrpcError = (error: unknown): boolean => {
  const code = (error as { code?: number })?.code;
  return typeof code === 'number' && TRANSIENT_GRPC_CODES.has(code);
};

const fetchWithRetry = (
  request: RecommendationsRequest,
  signal: AbortSignal | undefined,
  attempt: number,
): Promise<RecommendationsResponse> =>
  SkyscannerMichelinRecommendationsV1Recommendations.RecommendationsService.Recommendations(
    request,
    {
      pathPrefix: PATH_PREFIX,
      headers: { 'Content-Type': 'application/json' },
      signal,
    },
  ).catch((error: unknown) => {
    if (signal?.aborted) throw error;
    if (!isTransientGrpcError(error)) throw error;
    if (attempt >= MAX_RETRIES) throw error;

    return fetchWithRetry(request, signal, attempt + 1);
  });

export const getRecommendations = (
  request: RecommendationsRequest,
  signal?: AbortSignal,
): Promise<RecommendationsResponse> => fetchWithRetry(request, signal, 0);
